import { render, staticRenderFns } from "./CarbonFootprintPage.vue?vue&type=template&id=bc5979b8&scoped=true"
import script from "./CarbonFootprintPage.vue?vue&type=script&lang=ts"
export * from "./CarbonFootprintPage.vue?vue&type=script&lang=ts"
import style0 from "./CarbonFootprintPage.vue?vue&type=style&index=0&id=bc5979b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5979b8",
  null
  
)

export default component.exports